import * as actions from "./actions";
import {
   initPhotosetsDetails,
   getPhotosetById,
   photosetToggleLike,
   photosetPreReleaseForFree,
   photosetToggleWatched,
   addPhotosetView,
}  from 'sites/api/MixApi';
import {
   fetchResourcesOperation,
}  from 'sites/state/modules/media-resources/operations';
import {
   getMediaCommentsOperation,
}  from 'sites/state/modules/media-comments/operations';
import { push } from 'connected-react-router';
import Router from 'sites/routes/router';
import { setSendModalState } from 'sites/state/modules/purchase-send/actions';
import toast from "common/utils/toast";

export function fetchPhotosetsOperation(param, bool) {
   return async dispatch => {
      dispatch(actions.fetchRequest());
      try {
         const { data }  = await initPhotosetsDetails(param);
         // await dispatch(fetchResourcesOperation('photosets', ['tags, cast_members']))
         await dispatch(fetchResourcesOperation('photosets', 'photoset'))
         dispatch(actions.fetchRequestCompleted(data, bool))
      } catch (error) {
         dispatch(actions.fetchRequestFailed(error));
      }
   }
}

export function fetchPhotosetsByFilterOperation(params = []) {
   return async dispatch => {
      dispatch(actions.fetchRequestByFilter());
      try {
         const { data }  = await initPhotosetsDetails(params, true);
         dispatch(actions.fetchRequestByFilterCompleted(data))
      } catch (error) {
         dispatch(actions.fetchRequestByFilterFailed(error));
      }
   }
}

export function fetchPhotosetById(id, isAuthUser, callBack, param = []) {
   return async (dispatch) => {
      dispatch(actions.fetchPhotosetByIdRequest());
      try {
         const { data }  = await getPhotosetById(id);
         if(!data.is_deleted){
            if(!!data.can_read_comments) {
               const commentsCount = data.comments_count;
               await dispatch(getMediaCommentsOperation(data.id, 'photosets', commentsCount, param))
            }
            if(isAuthUser && !data.watched && !Boolean(data.is_available_pricings) && 'free' === data.stream_state) {
               await photosetToggleWatched(id, { watched: true });
               dispatch(actions.toggleWatchedCompleted(id));
            }
         }
         dispatch(actions.fetchPhotosetByIdCompleted(data))
         if(callBack){
            callBack(data)
         }
      } catch (error) {
         const status = error?.response?.status;
         if(403 !== status && 401 !== status){
            dispatch(push({
               pathname: Router.route("PHOTOSETS").getCompiledPath(),
            }))
         }
         dispatch(actions.fetchPhotosetByIdFailed(error));
      }
   }
}

export function toggleLikeOperation(id, isLike, successCallBack) {
   return async dispatch => {
      // dispatch(actions.toggleLikeRequest());
      try {
         await photosetToggleLike(id);
         dispatch(actions.toggleLikeCompleted(id, isLike))
         if(successCallBack) successCallBack(id, isLike)
      } catch (error) {
         // dispatch(actions.toggleLikeFailed(error));
      }
   }
}

export function fetchNextPhotosetOperation(params) {
   return async dispatch => {
      dispatch(actions.fetchNextPhotosetRequest());
      try {
         const { data }  = await initPhotosetsDetails(params);
         dispatch(actions.fetchNextPhotosetCompleted(data))
      } catch (error) {
         dispatch(actions.fetchNextPhotosetFailed(error));
      }
   }
}
export function preReleaseForFreeOperation(id, param = []) {
   return async dispatch => {
      dispatch(setSendModalState({ paymentButtonLoading: true }))
      try {
         const { data }  = await photosetPreReleaseForFree(id);
         if(!!data.can_read_comments) {
            const commentsCount = data.comments_count;
            await dispatch(getMediaCommentsOperation(data.id, 'photosets', commentsCount, param))
         }
         dispatch(actions.fetchPhotosetByIdCompleted(data))
         dispatch(setSendModalState({ paymentButtonLoading: false }))
      } catch (error) {
         if(error?.response?.data?.need_to_update) {
            toast.error(error.response.data.need_to_update[0])
            if(error.response.data.data) {
               const newData = error.response.data.data
               dispatch(actions.fetchPhotosetByIdCompleted(newData))
            }
         }
         dispatch(setSendModalState({ paymentButtonLoading: false }))
      }
   }
}

export function toggleWatchedOperation(id, data, successCallBack) {
   return async dispatch => {
      try {
         await photosetToggleWatched(id, data);
         dispatch(actions.toggleWatchedCompleted(id))
         if(successCallBack) successCallBack()
      } catch (error) {
      }
   }
}

export function updatePhotosetDataAfterPurchaseOperation(data) {
   return async dispatch => {
      try {
         await photosetToggleWatched(data.id, { watched: true })
         if(!data.is_deleted && !data.is_future_publish_enabled){
            addPhotosetView(data.id)
         }
         dispatch(actions.updateDataAfterPurchaseCompleted(data))
      } catch (error) {

      }
   }
}
